import Parse from "parse";

import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_Order } from "./SIV_Order";
import type { _User } from "./_User";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_ContainerAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  containerAssignments: any[];
  containerNo?: string | undefined;
  containerType?: string | undefined;
  deliveryDate?: Date | undefined;
  deliveryNote?: SIV_DeliveryNotes | undefined;
  deliveryNoteNo?: string | undefined;
  directory?: string | undefined;
  directoryDate?: Date | undefined;
  dunnageWeight?: number | undefined;
  grossWeight?: number | undefined;
  netWeight?: number | undefined;
  no: string;
  notFoundValues: any;
  order: SIV_Order;
  ownWeight?: number | undefined;
  packagingEndDate?: Date | undefined;
  packagingLocation?: string | undefined;
  packagingType?: string | undefined;
  packedBy?: _User | undefined;
  packingDate?: Date | undefined;
  sealNo?: string | undefined;
  shortDescription?: string | undefined;
  sivFacility?: string | undefined;
  statusCompletion?: string | undefined;
  statusInvoice?: string | undefined;
  statusProcess?: string | undefined;
  storageInstruction?: string | undefined;
  tenant?: OD3_Tenant | undefined;
  volume?: number | undefined;
}

export class SIV_Container extends Parse.Object<SIV_ContainerAttributes> {
  static className: string = "SIV_Container";

  constructor(data?: Partial<SIV_ContainerAttributes>) {
    super("SIV_Container", data as SIV_ContainerAttributes);
  }

  get containerAssignments(): any[] {
    return super.get("containerAssignments");
  }
  set containerAssignments(value: any[]) {
    super.set("containerAssignments", value);
  }

  get containerNo(): string | undefined {
    return super.get("containerNo");
  }
  set containerNo(value: string | undefined) {
    super.set("containerNo", value);
  }

  get containerType(): string | undefined {
    return super.get("containerType");
  }
  set containerType(value: string | undefined) {
    super.set("containerType", value);
  }

  get deliveryDate(): Date | undefined {
    return super.get("deliveryDate");
  }
  set deliveryDate(value: Date | undefined) {
    super.set("deliveryDate", value);
  }

  get deliveryNote(): SIV_DeliveryNotes | undefined {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes | undefined) {
    super.set("deliveryNote", value);
  }

  get deliveryNoteNo(): string | undefined {
    return super.get("deliveryNoteNo");
  }
  set deliveryNoteNo(value: string | undefined) {
    super.set("deliveryNoteNo", value);
  }

  get directory(): string | undefined {
    return super.get("directory");
  }
  set directory(value: string | undefined) {
    super.set("directory", value);
  }

  get directoryDate(): Date | undefined {
    return super.get("directoryDate");
  }
  set directoryDate(value: Date | undefined) {
    super.set("directoryDate", value);
  }

  get dunnageWeight(): number | undefined {
    return super.get("dunnageWeight");
  }
  set dunnageWeight(value: number | undefined) {
    super.set("dunnageWeight", value);
  }

  get grossWeight(): number | undefined {
    return super.get("grossWeight");
  }
  set grossWeight(value: number | undefined) {
    super.set("grossWeight", value);
  }

  get netWeight(): number | undefined {
    return super.get("netWeight");
  }
  set netWeight(value: number | undefined) {
    super.set("netWeight", value);
  }

  get no(): string {
    return super.get("no");
  }
  set no(value: string) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get ownWeight(): number | undefined {
    return super.get("ownWeight");
  }
  set ownWeight(value: number | undefined) {
    super.set("ownWeight", value);
  }

  get packagingEndDate(): Date | undefined {
    return super.get("packagingEndDate");
  }
  set packagingEndDate(value: Date | undefined) {
    super.set("packagingEndDate", value);
  }

  get packagingLocation(): string | undefined {
    return super.get("packagingLocation");
  }
  set packagingLocation(value: string | undefined) {
    super.set("packagingLocation", value);
  }

  get packagingType(): string | undefined {
    return super.get("packagingType");
  }
  set packagingType(value: string | undefined) {
    super.set("packagingType", value);
  }

  get packedBy(): _User | undefined {
    return super.get("packedBy");
  }
  set packedBy(value: _User | undefined) {
    super.set("packedBy", value);
  }

  get packingDate(): Date | undefined {
    return super.get("packingDate");
  }
  set packingDate(value: Date | undefined) {
    super.set("packingDate", value);
  }

  get sealNo(): string | undefined {
    return super.get("sealNo");
  }
  set sealNo(value: string | undefined) {
    super.set("sealNo", value);
  }

  get shortDescription(): string | undefined {
    return super.get("shortDescription");
  }
  set shortDescription(value: string | undefined) {
    super.set("shortDescription", value);
  }

  get sivFacility(): string | undefined {
    return super.get("sivFacility");
  }
  set sivFacility(value: string | undefined) {
    super.set("sivFacility", value);
  }

  get statusCompletion(): string | undefined {
    return super.get("statusCompletion");
  }
  set statusCompletion(value: string | undefined) {
    super.set("statusCompletion", value);
  }

  get statusInvoice(): string | undefined {
    return super.get("statusInvoice");
  }
  set statusInvoice(value: string | undefined) {
    super.set("statusInvoice", value);
  }

  get statusProcess(): string | undefined {
    return super.get("statusProcess");
  }
  set statusProcess(value: string | undefined) {
    super.set("statusProcess", value);
  }

  get storageInstruction(): string | undefined {
    return super.get("storageInstruction");
  }
  set storageInstruction(value: string | undefined) {
    super.set("storageInstruction", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }

  get volume(): number | undefined {
    return super.get("volume");
  }
  set volume(value: number | undefined) {
    super.set("volume", value);
  }
}

Parse.Object.registerSubclass("SIV_Container", SIV_Container);
